import React from "react";
import { MuiX } from "@osu/react-ui";
import { getLocalDateForTimeZone } from "../../../../util/functions";

const TimePicker = (props = {}) => {
  const displayValue = (props?.value ? getLocalDateForTimeZone(props.value) : props?.value);
  return (<MuiX.TimePicker {...props} value={displayValue} />);
};

export default TimePicker;
